import { FC } from 'react';
import { useSelector } from 'react-redux';

import { ScrubAddressModalType, selectScrubbedAddress } from '@app/redux/scrubbedAddress';

import { ErrorAddressModal } from './ErrorAddressModal';
import { IncorrectAddressModal } from './IncorrectAddressModal';
import { LoadingModal } from './LoadingModal';
import { SuggestedAddressModal } from './SuggestedAddressModal';

export const ScrubAddressModal: FC<{
  isLoading: boolean;
  isModalOpen: boolean;
  handleClose: () => void;
  handleRetry?: () => void;
  handleSave: () => void;
  suggestedAddress: string[];
  namespace: string;
}> = ({ isLoading, isModalOpen, handleClose, handleRetry, handleSave, suggestedAddress, namespace }) => {
  const { modalType } = useSelector(selectScrubbedAddress);

  if (isLoading) {
    return <LoadingModal ns={namespace} isOpen={isModalOpen} />;
  }

  switch (modalType) {
    case ScrubAddressModalType.AddressError:
      return <ErrorAddressModal ns={namespace} isOpen={isModalOpen} onClose={handleClose} onRetry={handleRetry} />;
    case ScrubAddressModalType.IncorrectAddress:
      return <IncorrectAddressModal ns={namespace} isOpen={isModalOpen} onClose={handleClose} />;
    default:
      return (
        <SuggestedAddressModal
          ns={namespace}
          isOpen={isModalOpen}
          handleClose={handleClose}
          handleSave={handleSave}
          suggestedAddress={suggestedAddress}
        />
      );
  }
};
